import React, { Fragment, useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader'
import EmailInput from '../reusableComponents/EmailInput'
import FilterEmailInput from '../reusableComponents/FilterEmailInput'
import { useDispatch, useSelector } from 'react-redux'
import { setV2PRMData } from '../../services/redux/V2PRMReducer'
import { createV2PRMApi, v2pRMApi } from '../../services/redux/ApiActions'
import showNotification from '../../services/redux/NotifcationService'
import { Transition } from '@headlessui/react'
import LogoDiv from '../Common/LogoDiv'
import { emailRegex } from '../Common/EmailRegex'
import logo from '../../img/BBPS_Horizontal.png';

const V2PRM = () => {
    const [userData, setUserData] = useState({
        email: '',
    })
    const [filterEmail, setFilterEmail] = useState('')
    const [selectedValue, setSelectedValue] = useState();
    const [isRMModalOpen, setIsRMModalOpen] = useState(false);

    const v2pRMData = useSelector((state) => state.v2pRMData.V2PRMData);
    const loginData = useSelector((state) => state.login.loginData);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }
    const AddV2PRM = async (item) => {
        const V2PRMPayload = {
            name: filterEmail === null || filterEmail === '' ? userData.email : filterEmail,
            email: filterEmail === null || filterEmail === '' ? userData.email : filterEmail,
            id: item === undefined || item === null || item === '' ? 0 : item,
        }
        // console.log(V2PRMPayload)
        if (filterEmail !== '' || userData.email !== '') {
            if (!emailRegex.test(filterEmail || userData.email)) {
                showNotification('Please enter a valid email', 'error');
                return;
            }
            try {
                const V2PRmResponse = await dispatch(createV2PRMApi(V2PRMPayload, loginData?.token_chr))
                if (V2PRmResponse.statusCode === 200) {
                    v2pRM_API_CALL();
                    setIsRMModalOpen(false);
                    showNotification('V2PRM Added Successfully', 'success');
                    setFilterEmail('')
                } else {
                    showNotification('V2PRM Exists Already', 'error');

                }
            } catch (error) {
                showNotification(error, 'error');
                setFilterEmail('')
            }
        } else {
            showNotification('Please enter an email address.', 'error');
        }

    }

    const v2pRM_API_CALL = async () => {
        const v2pRmResponse = await dispatch(v2pRMApi(loginData?.token_chr))
        if (v2pRmResponse) {
            dispatch(setV2PRMData(v2pRmResponse?.result))

        }

    }

    const EditV2PRM = async (item) => {
        setIsRMModalOpen(true);
        setUserData({ ...userData, email: item.email })
        setSelectedValue(item.id)
    }

    return (
        <div className='mailsentbody'>
            <LogoDiv className='logoBG'>
                <div className="rightElement">
                    <DashboardHeader />
                    <div className="grid mt-6 grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                        <div className="col-span-12 md:col-span-10 lg:col-span-10 ">
                            <div className="flex items-center justify-between mt-2 p-2 mx-4">
                                <div className="col-span-6">
                                    <h1 className="text-4xl font-medium ">V2P RM List</h1>
                                </div>
                                <div style={{padding:'5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
                            </div>
                            <div className='bg-white mx-2 shadow-md p-6 mt-4 rounded-lg'>
                                <div className='grid mt-1 mb-7 grid-cols-12 gap-4'>
                                    <div className="col-span-5 md:col-span-5 lg:col-span-3">
                                        <label htmlFor="email" className="block text-md font-medium leading-6 text-gray-900">V2PRM Email</label>
                                        <FilterEmailInput name='filterEmail' value={filterEmail} onChange={(e) => setFilterEmail(e.target.value)} inputStyles={{ paddingLeft: '10px', padding: '15px 10px' }} />
                                    </div>
                                    <div className="col-span-5 mt-6 md:col-span-5 lg:col-span-3">
                                        <button onClick={() => AddV2PRM()} className='vtpRm-action-button'>Add New V2PRM</button>
                                    </div>
                                </div>
                                <div className="overflow-x-auto mt-2 border rounded-md shadow-sm shadow-sm">

                                    <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y  divide-gray-200">
                                        <thead className="bg-white-400">
                                            <tr>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black border border-r-black-200 uppercase tracking-wider">
                                                    Sr. No.
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black border border-r-black-200 uppercase tracking-wider">
                                                    V2PRM
                                                </th>

                                                <th scope="col" className="px-6 py-3 text-lefte text-xs font-medium text-black  uppercase tracking-wider">
                                                    Action
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200 ">
                                            {v2pRMData?.map((item, index) => (
                                                <tr key={item.id} className='border-t'>
                                                    <td className="px-6  whitespace-nowrap border border-r-black-200" > {index + 1}</td>
                                                    <td className="px-6  whitespace-nowrap border border-r-black-200">{item.email}</td>
                                                    <td className="px-6  whitespace-nowrap text-left">
                                                        <button onClick={() => EditV2PRM(item)} className="px-4 py-2  text-blue-500 rounded hover:text-blue-700">
                                                            Edit
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <Transition
                                as={Fragment}
                                show={isRMModalOpen}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity flex items-center justify-center">
                                    <div className="bg-white rounded-lg w-full max-w-xl max-w-xl">
                                        <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
                                            <Transition
                                                as={Fragment}
                                                enter="ease-out duration-300"
                                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                                leave="ease-in duration-200"
                                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                            >
                                                <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-md sm:max-w-lg h-auto">
                                                    <div className='py-3 flex justify-between'>
                                                        <h1 className='text-lg mt-1'>Edit V2PRM</h1>
                                                        <div className='p-1 hover:cursor-pointer' onClick={() => setIsRMModalOpen(false)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                    <div className='border-t'>
                                                        <h1 className='mt-4 text-sm font-bold'>V2PRM Email</h1>
                                                        <EmailInput name='email' onChange={handleChange} value={userData.email} inputStyles={{ padding: '15px' }} />
                                                    </div>
                                                    <div className='mt-4 text-center'>
                                                        <button onClick={() => AddV2PRM(selectedValue)} className='vtpRm-action-button'>Update</button>
                                                    </div>
                                                    <div className='border-t p-4 mt-4'></div>
                                                </div>
                                            </Transition>
                                        </div>
                                    </div>
                                </div>
                            </Transition>
                        </div>
                        <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                    </div>
                </div>
            </LogoDiv >
        </div >
    )
}

export default V2PRM
